import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const CreatorTabContentBackground = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-top: 1rem;

  color: ${({ theme }) => theme.freecode.color};

  & :is(h1, h2, h3, h4, h5, h6) {
    color: ${({ theme }) => theme.freecode.activeAreaColor};
  }
  & input,
  & label,
  & p {
    color: ${({ theme }) => theme.freecode.color};
  }

  & input {
    background-color: ${({ theme }) => theme.freecode.headerBackground};
    border-color: ${colors.gray};
  }
  & input:disabled {
    background-color: ${({ theme }) => theme.freecode.headerBackground};
    border-color: ${colors.gray};
  }
`;

export const CreatorTabRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;

  & label {
    margin-bottom: 0;
  }
`;

export const CreatorTabColumnContainer = styled.div`
  padding: 0 0.75rem;
  margin: 0 auto;
  flex: 50%;
  min-width: 310px;
`;

export const SectionHeader = styled.h3`
  color: ${({ theme }) => theme.freecode.activeAreaColor};
  margin-bottom: 5px;
`;

export const CreatorSection = styled.section`
  padding-bottom: 1rem;

  ${({ paddingX }) =>
    paddingX &&
    css`
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    `}
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  gap: 5px;
`;

export const Label = styled.label`
  font-size: 14px;

  color: ${({ theme }) => theme.freecode.color};

  ${({ hideOverflow }) =>
    hideOverflow &&
    css`
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
    `}

  ${({ noWrap }) =>
    noWrap &&
    css`
      white-space: nowrap;
    `}
  ${({ displayBlock }) =>
    displayBlock &&
    css`
      display: block;
    `}
`;

export const Text = styled.p`
  font-size: 14px;
  color: ${colors.darkGray};
  margin-bottom: 0px;
`;

export const ErrorText = styled(Text)`
  color: ${colors.red} !important;
`;

export const NumberInput = styled.input.attrs((props) => ({
  type: props.isText ? 'text' : 'number',
}))`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: 0.75rem;
    `}
`;

export const HiddenFileInput = styled.input.attrs({ type: 'file' })`
  display: none;
`;
